/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import AccordionListModule from 'bundles/degree-description/components/modules/program-details/AccordionListModule';

export type CurriculumItem = {
  id: string;
  title: string;
  supportText: string;
  courses: string[];
};

export type CurriculumModuleProps = {
  heading: string;
  description: string;
  items: CurriculumItem[];
};

const styles = {
  courseList: css`
    margin: 0;
    padding: 0;
    list-style: none;
  `,
  course: css`
    padding: var(--cds-spacing-100) 0;

    &:not(:last-of-type) {
      border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    }
  `,
};

const CurriculumModule = ({ heading, description, items }: CurriculumModuleProps) => (
  <AccordionListModule
    heading={heading}
    description={description}
    sections={[
      {
        items: items.map((item) => ({
          id: item.id,
          label: item.title,
          supportText: item.supportText,
          content: (
            <ul css={styles.courseList}>
              {item.courses.map((course) => (
                <li css={styles.course} key={course}>
                  <Typography2 variant="bodySecondary" component="span">
                    {course}
                  </Typography2>
                </li>
              ))}
            </ul>
          ),
        })),
      },
    ]}
  />
);

export default CurriculumModule;
